<p-dialog
    [style]="artifactType === 'Document' ? documentDialogStyle : {}"
    [modal]="true"
    [(visible)]="showDialog"
    appendTo="body"
    [dismissableMask]="true"
    header="document"
>
    <ng-template pTemplate="header">
        <div class="show-document-dialog-header">
            <div>
                <p class="p-dialog-title">
                    <i
                        [class]="
                            (artifactType | artifactTypeIcon) + ' large-icon'
                        "
                    ></i>
                    {{ artifactType }}
                </p>
                {{ artifact?.name }}
            </div>
            <div>
                <button
                    class="p-button-rounded p-button-text p-button-plain"
                    icon="pi pi-download"
                    pButton
                    (click)="documentHelper.downloadDocument(artifact, { outdated: !!outdatedReason })"
                    ></button>
                <button
                    class="p-button-rounded p-button-text p-button-plain p-mr-1"
                    icon="pi pi-external-link"
                    pButton
                    (click)="freyaHelper.openInNewTab(artifactSrc)"
                    ></button>
            </div>
        </div>
    </ng-template>
    <div class="artifact-dialog-body">
        <p-messages *ngIf="outdatedReason" severity="warn" [closable]="false">
            <ng-template pTemplate>
                <span>
                    <strong>This document is outdated.</strong>
                    {{ outdatedReason }}
                </span>
            </ng-template>
        </p-messages>
        <iframe
            *ngIf="artifactType === 'Document'"
            [src]="artifactSrc | trustUrl"
            frameborder="0"
            width="100%"
        ></iframe>
        <img *ngIf="artifactType === 'Image'" [src]="artifactSrc" />
    </div>
</p-dialog>
